import { graphql } from '@/generated/gql';

export const DEMAND_CONVERSATION_SETTINGS_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation DemandConversationSettingsUpdate($data: SvbrgConversationSettingsUpdateMutation!) {
    sevenbridges {
      conversationSettings {
        update(data: $data) {
          id
          entityId
          entityVariant
          tools {
            id
            isEnabled
          }
          quickActions {
            id
            prompt
            translations {
              id
              language
              text
              variant
            }
            isConversationStarter
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`);
